<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> {{ $t('RULECATEGORIES') }}
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-3">
                                <b-form-fieldset v-bind:label="$t('SEARCH')">
                                    <b-form-input v-model="pagination.query"></b-form-input>
                                </b-form-fieldset>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
                        <p class="center">{{ $t('NODATAFOUND') }}</p>
                    </div>
                    <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
                        <table class="table table-responsive-sm table-striped">
                            <thead>
                                <tr>
                                    <th>{{ $t('MODULENAME') }}</th>
                                    <th>{{ $t('ACTION') }}</th>
                                    <th>{{ $t('SUCCESS') }}</th>
                                    <th>{{ $t('DATETIME') }}</th>
                                    <th>{{ $t('USERNAME') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(item, i) in data.root">
                                    <tr :key="i">
                                        <td>{{ item.moduleName }}</td>
                                        <td>{{ $t(item.action.toUpperCase()) }}</td>
                                        <td>{{ item.success ? $t('YES') : $t('NO') }}</td>
                                        <td>{{ item.dateTime }}</td>
                                        <td>{{ item.username }}</td>
                                    </tr>
                                    <tr :key="i">
                                        <td colspan="5">{{ item.ruleData }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                        <nav>
                            <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Api from '@/api/ActionLog';

export default {
    name: 'Rules',
    data()
    {
        return {
            data: {},
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 20,
                searchTimeout: false,
            },
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
    {
        async getData()
        {
            const me = this;
            const data = await Api.selectRow(me.getParams);

            if (data.error && data.error === true)
            {
                me.$notify.notice(data);
                return;
            }

            me.data = data;
        },
    },
    watch:
    {
        'pagination.currentPage'()
        {
            const me = this;
            me.getData();
        },
        'pagination.query'()
        {
            const me = this;

            if (me.pagination.searchTimeout !== false)
            {
                clearTimeout(me.pagination.searchTimeout);
            }

            me.pagination.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.pagination.searchTimeout = false;
            }, 300);
        },
    },
    computed:
    {
        getParams()
        {
            const me = this;
            const data = { ...me.pagination };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
    },
};
</script>
